
const PORTER_GUIDE_ID = process.env.REACT_APP_PORTER_GUIDE_ID;

export const getGuideDataById = id => selector => selector.guides.get(id);

export const getGuideSearchQuery = selector => selector.guideSearchQuery.get();

export const getAllGuideIds = selector => selector.guides.allIds();

export const getGuideSearchFilters = selector => selector.guideSearchFilters.get();

export const getGuideSortKeys = selector => selector.guideSortKeys.get();

export const getTreks = selector => selector.treks.allIds();

export const getTrekById = id => selector => selector.treks.get(id);

// =============== FILTER FUNCTIONS ==================
const baseCityFilter = (guide, city) => {
  const { livesIn, baseCity } = guide;

  if (city === '' || city === null) return true;

  if (baseCity) {
    return baseCity.toLowerCase().includes(city.toLowerCase());
  } else if (livesIn) {
    return livesIn.toLowerCase().includes(city.toLowerCase());
  } else {
    return false;
  }
};

const languagesFilter = (guide, languages) => {
  if (languages && languages.length <= 0) return true;
   
  if (guide.languages && guide.languages.length > 0) {
    return languages.every(ln => guide.languages.includes(ln));
  } else {
    return false;
  }
};

const experienceFilter = (guide, experience) => {
  if (!experience) return true;

  if (!guide.experienceYears) return false;
  
  return Number(guide.experienceYears) >= Number(experience);
}

const femaleOnlyFilter = (guide, femaleOnly) => {
  if (!femaleOnly) return true;
  
  if (!guide.gender) return false;

  if (femaleOnly) {
    return guide.gender === 'F';
  }
}

const filters = {
  baseCity: baseCityFilter,
  languages: languagesFilter,
  experience: experienceFilter,
  femaleOnly: femaleOnlyFilter,
}

// ============= SORT FUNCTION ======================

const sortByAverageRating = order => (guideA, guideB) => (guideA.averageRating - guideB.averageRating) * order;
const sortByExperienceYears = order => (guideA, guideB) => (guideA.experienceYears - guideB.experienceYears) * order;
const sortByPrice = order => (guideA, guideB) => {
  if (!guideA.dailyWages) return -1 * order;
  if (!guideB.dailyWages) return -1 * order;

  return (guideA.dailyWages.amount - guideB.dailyWages.amount) * order;
};

const sortFunctions = {
  sortByPrice,
  sortByAverageRating,
  sortByExperienceYears,
};

// =================================================

export const getFilteredGuideIds = selector => {
  // FILTER OUT PORTER GUIDE FROM GUIDE LIST AND GUIEDS WITH NO DAILY WAGE
 const guideIds = (selector.guides.allIds() || []).filter(id => id !== PORTER_GUIDE_ID && selector.guides.get(id).dailyWages !== null);
 const guideSortKeys = selector.guideSortKeys.get();
 const guideFilters = selector.guideSearchFilters.get();

 return selector.memoize(() => {
    const filterKeys = Object.keys(guideFilters || {});

    let sortedGuideIds = guideIds;

    if (guideSortKeys) {
      const { sortFunction, order } = guideSortKeys;
      sortedGuideIds = guideIds.map(id =>  selector.guides.get(id)).sort(sortFunctions[sortFunction](order)).map(guide => guide.id);
    }

    if (filterKeys.length === 0) return sortedGuideIds;

    return sortedGuideIds.filter(id => {
      const guide = selector.guides.get(id);
      for(let i = 0;i < filterKeys.length; i++) {
        const key = filterKeys[i];
        const filter = filters[key];
        if (!filter(guide, guideFilters[key])) return false;
      }
      return true;
    });
  }, [guideIds, guideFilters, guideSortKeys]);
};
